export default __webpack_public_path__ + "static/nano_horz_color-0decb759ac2038306dccdabbfca271af.jpg";